import '../sass/Profil.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faCircleArrowDown } from '@fortawesome/free-solid-svg-icons'

function Profil() {
    return <div className="profil" id='profil'>
        <FontAwesomeIcon icon={faCode} size='2xl' style={{color: "#2965FF"}} />
        <h2>MON PROFIL :</h2>
        <p>Développeur web full stack diplômé d'un master chez Toulouse YNOV Campus, 
            je suis à la recherche d'un CDI ou d'une mission en freelance. Curieux et polyvalent, j'ai également de l'expérience en cadrage et en pilotage de projet.</p>
        <FontAwesomeIcon icon={faCircleArrowDown} size='2xl' style={{color: "#2965FF"}} />
    </div>
}
export default Profil
